import type { ReactNode } from "react";
import emailConfirmationIllustration from "@/assets/froppio-email-confirmation.svg";

export function EmailConfirmationIntro({ children }: { children?: ReactNode }) {
  return (
    <div className="mx-auto flex min-h-0 w-full max-w-md flex-1 flex-col items-center justify-center gap-[min(22px,2dvh)] text-center">
      <div className="min-h-0 w-60 max-w-full max-h-[206px] flex-1">
        <img src={emailConfirmationIllustration} width={280} height={240} alt="Froppio holding an envelope" className="h-full w-full object-contain" />
      </div>
      {children && <div className="w-full shrink-0 space-y-3 text-sm leading-relaxed text-muted-foreground">{children}</div>}
    </div>
  );
}
